import { useEffect, useState } from 'react';
import isNull from '../../../../../../../../utils/NullChecking'
import { IconAlertGradient } from '../../../../../../../shared/IconsComponent/icons'
import SuperSearchList from '../../../../../../../shared/SuperSearch/SuperSearchList'
import { enumUtil } from '../../../../../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../utils/NotificationHandler';
const AIEncounterSummaryPreview = ({ generatedNotes, setGeneratedNotes, initialData }) => {
    const API_URL = enumUtil.controller.PatientEncounter

    const [isLoading, setIsLoading] = useState(false)
    const [is, setIs] = useState(true);
    const [patientData, setPatientData] = useState([])
    useEffect(() => {
        if (!isNull(initialData?.Data?.GroupIdentifier)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/EncounterPatient", 'post', {
                "TableName": enumUtil.enumAPITableName.GroupNote,
                "SearchCriteria": {
                    "GroupIdentifier": initialData?.Data?.GroupIdentifier
                }
            }).then((response) => {
                setIsLoading(false)
                setPatientData(response)
            }).catch((error) => {
                setIsLoading(false)
                setPatientData([])
            })
        }

    }, [])
    const handleChangePatient = (e, index) => {
        setIs(false);

        let { name, value } = e.target;
        let data = { ...generatedNotes }
        data.MainCustomTemplate[0].Data[0].items[index].PatientName = value
        // data.MainCustomTemplate[0].Data[0].items[index].SpeakerLabel = value
        setGeneratedNotes(data)
        // if (!e?.target?.value) {
        //     setGeneratedNotes(prev => {
        //         const updated = structuredClone(prev);

        //         // updated.MainCustomTemplate[0].Data[0].items[index].PatientID = "";
        //         updated.MainCustomTemplate[0].Data[0].items[index].PatientName = e?.target?.value;

        //         console.log('updated', updated);

        //         return updated;
        //     });
        // }
    }
    const handleSelectedData = (selectedData, name, type, index) => {
        //selectedData returns object including value that will be stored in items(generatednotes) patientid and value in patientName
        setIs(true);
        let data = { ...generatedNotes }

        if (type === 'client' && !isNull(selectedData)) {
            const items = generatedNotes?.MainCustomTemplate?.[0]?.Data?.[0]?.items || [];
            // const alreadyAssigned = items.some(
            //     (item, i) =>
            //         i !== index &&
            //         item.IsWidget !== "true" &&
            //         item.content === "Patient Summary" &&
            //         String(item.PatientID) === String(selectedData.value)
            // );
            const currentItem = items[index];

            const alreadyAssigned = items.some(
                (item, i) =>
                    i !== index &&
                    item.IsWidget !== "true" &&
                    item.IsRepeated === "true" &&
                    item.ItemID === currentItem.ItemID &&
                    String(item.PatientID) === String(selectedData.value)
            );

            if (alreadyAssigned) {
                NotificationHandler("This patient has already been assigned.", enumUtil.enumtoaster.error)
                return;
            }

            let data = { ...generatedNotes }
            data.MainCustomTemplate[0].Data[0].items[index].PatientName = selectedData.display
            // data.MainCustomTemplate[0].Data[0].items[index].SpeakerLabel = selectedData.display
            data.MainCustomTemplate[0].Data[0].items[index].PatientID = selectedData.value + ""

            setGeneratedNotes(data)
            // setGeneratedNotes(prev => {
            //     const updated = structuredClone(prev);

            //     updated.MainCustomTemplate[0].Data[0].items[index].PatientID = selectedData.value;
            //     updated.MainCustomTemplate[0].Data[0].items[index].PatientName = selectedData.name;

            //     return updated;
            // });
        } else {
            let data = { ...generatedNotes }
            data.MainCustomTemplate[0].Data[0].items[index].PatientName = ''
            // data.MainCustomTemplate[0].Data[0].items[index].SpeakerLabel = ''
            data.MainCustomTemplate[0].Data[0].items[index].PatientID = ''
            setGeneratedNotes(data)
        }


    }
    return (
        <div className="d-flex flex-column gap-10 group-summary">
            {!isNull(generatedNotes) &&
                generatedNotes?.MainCustomTemplate?.[0]?.Data?.[0]?.items?.map((item, index) => {
                    let itemID = !isNull(item?.ItemID) ? item?.ItemID?.split('-')[0] : ''
                    if (item?.IsWidget === 'true') return null;
                    if (itemID === 'FormattingTextField') return null;

                    return item.IsRepeated === 'false' ? (
                        <div className="d-flex flex-column gap-2" key={index}>
                            <p className="heading">{item.content}</p>
                            <p className="text">{item.answer}</p>
                        </div>
                    ) : (
                        <div className="d-flex flex-column gap-2" key={index}>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="heading">{item.SpeakerLabel ? item.SpeakerLabel : ''} {item.content}:</p>
                                <div className="input w-125px">
                                    <SuperSearchList
                                        type="client"
                                        id="PatientAISummary"
                                        name="Patient"
                                        icon={'Simple'}
                                        sup_btn="sup_btn"
                                        sup_inp="superSearchVisitInp"
                                        label="Select Patient"
                                        searchValue={item.PatientName}
                                        data={patientData}
                                        onChange={(e) => handleChangePatient(e, index)}
                                        getSelectedData={(selectedData, name, type) =>
                                            handleSelectedData(selectedData, name, type, index)
                                        }
                                        is={is}
                                    />
                                </div>
                            </div>
                            <p className="text">{item.answer}</p>
                        </div>
                    );
                })}
        </div>
    )
}

export default AIEncounterSummaryPreview